(() => {
  const endpoint = '/apps/wishlist';
  let statePromise;

  const login = () => {
    const returnUrl = `${location.pathname}${location.search}`;
    location.href = `/account/login?return_url=${encodeURIComponent(returnUrl)}`;
  };

  const request = async (options = {}) => {
    const response = await fetch(endpoint, {
      credentials: 'same-origin',
      headers: { Accept: 'application/json', 'Content-Type': 'application/json', ...(options.headers || {}) },
      ...options,
    });
    const data = await response.json().catch(() => ({}));
    if (response.status === 401 || data.error === 'LOGIN_REQUIRED') return { loginRequired: true };
    if (!response.ok || !data.ok) throw new Error(data.error || 'WISHLIST_REQUEST_FAILED');
    return data;
  };

  const loadState = () => {
    if (!statePromise) statePromise = request().catch((error) => ({ error }));
    return statePromise;
  };

  const setButtonState = (button, favorited) => {
    const text = favorited ? 'Remover da lista de desejos' : 'Adicionar à lista de desejos';
    button.setAttribute('aria-pressed', String(favorited));
    button.setAttribute('aria-label', text);
    button.querySelector('[data-wishlist-label]')?.replaceChildren(text);
  };

  const initialize = async (button) => {
    if (button.dataset.customerAuthenticated !== 'true') return;

    const state = await loadState();
    if (state.loginRequired || state.error) return;
    const productGid = `gid://shopify/Product/${button.dataset.productId}`;
    setButtonState(button, state.ids?.includes(productGid));
  };

  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-wishlist-button]');
    if (!button || button.getAttribute('aria-busy') === 'true') return;
    if (button.dataset.customerAuthenticated !== 'true') return login();

    const wasFavorited = button.getAttribute('aria-pressed') === 'true';
    setButtonState(button, !wasFavorited);
    button.setAttribute('aria-busy', 'true');
    try {
      const result = await request({ method: 'POST', body: JSON.stringify({ productId: button.dataset.productId }) });
      if (result.loginRequired) return login();
      setButtonState(button, result.favorited);
      statePromise = null;
    } catch (error) {
      setButtonState(button, wasFavorited);
      console.error('Wishlist:', error);
      button.setAttribute('title', 'Não foi possível atualizar a lista. Tente novamente.');
    } finally {
      button.removeAttribute('aria-busy');
    }
  });

  const boot = () => document.querySelectorAll('[data-wishlist-button]').forEach(initialize);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
})();
